import api from "../axiosInstance";

const appService = {
  getConfig: (queryParam = "") => api.get(`/user/config${queryParam}`),
  getModel: (id) => api.get(`/make/${id}/models`),
  getMenus: () => api.get("user/menu")
};

export default appService;
